import { useAuthFormStore } from "@store/authFormStore";

export const useLoginFormPersistence = () => {
    const { login, postResetEmail, setLoginEmail, setPostResetEmail, clearLogin } =
        useAuthFormStore();

    const getInitialEmail = (propsEmail?: string) => {
        return propsEmail || postResetEmail || login.email || "";
    };

    const handleClearLogin = () => {
        setPostResetEmail(null);
        clearLogin();
    };

    return {
        getInitialEmail,
        saveEmail: setLoginEmail,
        clearLogin: handleClearLogin,
    };
};
